import { initializeApp, getApps, getApp } from "firebase/app";
import {
  getAuth,
  signInWithPopup,
  GoogleAuthProvider,
  signOut as firebaseSignOut,
} from "firebase/auth";

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
};

export const isFirebaseConfigured = Boolean(
  firebaseConfig.apiKey && firebaseConfig.authDomain && firebaseConfig.projectId
);

// Initialised on first use rather than at import time, so a missing/blank
// .env can't take the whole app down on load.
const getFirebaseAuth = () => {
  if (!isFirebaseConfigured) {
    throw new Error(
      "Firebase isn't configured. Add the REACT_APP_FIREBASE_* values to .env and restart the dev server."
    );
  }

  // getApps() guards against re-initialising during hot reloads.
  const app = getApps().length ? getApp() : initializeApp(firebaseConfig);
  return getAuth(app);
};

/**
 * Opens the Google popup and returns the Firebase ID token that the backend
 * expects at POST /auth/firebase.
 */
export const signInWithGoogle = async () => { 
  const auth = getFirebaseAuth();

  const provider = new GoogleAuthProvider();
  provider.setCustomParameters({ prompt: "select_account" });

  const result = await signInWithPopup(auth, provider);
  const idToken = await result.user.getIdToken();

  return {
    idToken,
    user: {
      uid: result.user.uid,
      name: result.user.displayName,
      email: result.user.email,
      photoURL: result.user.photoURL,
    },
  };
};

export const signOutFirebase = async () => {
  if (!isFirebaseConfigured) return;
  await firebaseSignOut(getFirebaseAuth());
};

export default getFirebaseAuth;
